import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NumericInputComponent } from '../../../form-components/numeric-input/numeric-input.component';

@Component({
  selector: 'app-review-number-input',
  templateUrl: './review-number-input.component.html',
  styleUrls: ['./review-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewNumberInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewNumberInputComponent extends NumericInputComponent {}
